import React from 'react';
import { MessageCircle, Mail, Download, Share2 } from 'lucide-react';
import { fileUrl } from '../gameUtils';

const pill = 'inline-flex items-center gap-1.5 px-3 py-1.5 rounded-md text-xs font-semibold border disabled:opacity-50';
const neutralPill = `${pill} bg-white/5 text-white/80 border-white/15 hover:bg-white/10`;

export function BoxScoreShareRow({ generating, onWhatsApp, onMail, onDownload, onShareLandscape }) {
  return (
    <div className="px-3 sm:px-5 pb-6">
      <div className="flex items-center justify-center gap-2 flex-wrap pt-1 pb-3" data-testid="boxscore-share-row">
        <button onClick={onWhatsApp} disabled={generating}
          className={`${pill} bg-emerald-500/15 text-emerald-300 border-emerald-400/40 hover:bg-emerald-500/25`}
          data-testid="boxscore-whatsapp-link">
          <MessageCircle className="w-3.5 h-3.5" /> WhatsApp
        </button>
        <button onClick={onMail} disabled={generating} className={neutralPill} data-testid="boxscore-email-link">
          <Mail className="w-3.5 h-3.5" /> Email
        </button>
        <button onClick={onDownload} disabled={generating} className={neutralPill} data-testid="boxscore-download-btn">
          <Download className="w-3.5 h-3.5" /> Download PNG
        </button>
        <button onClick={onShareLandscape} disabled={generating}
          className={`${pill} bg-amber-400/10 text-amber-300 border-amber-400/40 hover:bg-amber-400/20`}
          data-testid="boxscore-share-row-btn">
          <Share2 className="w-3.5 h-3.5" /> AirDrop / More
        </button>
      </div>
    </div>
  );
}

function BannerTeam({ team, score, testId, reverse }) {
  const logo = team.logo && (
    <img src={fileUrl(team.logo)} alt="" className="w-7 h-7 rounded-full bg-white object-cover border border-white/20" />
  );
  return (
    <div className={reverse ? 'text-left' : 'text-right'}>
      <div className={`flex items-center gap-2 ${reverse ? '' : 'justify-end'}`}>
        {!reverse && logo}
        <div>
          <div className="text-[11px] uppercase tracking-widest text-white/50 truncate">{team.name}</div>
          <div className="text-3xl sm:text-4xl font-black tabular-nums" data-testid={testId}>{score}</div>
        </div>
        {reverse && logo}
      </div>
    </div>
  );
}

export function BoxScoreBanner({ game, scoreA, scoreB, period }) {
  return (
    <div className="bg-gradient-to-r from-[#001A5C] via-[#0F1A4A] to-[#001A5C] px-5 py-3 grid grid-cols-3 items-center text-white">
      <BannerTeam team={game.team_a} score={scoreA} testId="bs-score-a" />
      <div className="text-center">
        <div className="text-white/40 text-xs uppercase tracking-widest mb-1">Live Box Score</div>
        <div className="inline-block bg-amber-400 text-black text-xs font-black px-2 py-0.5 rounded">{period}</div>
      </div>
      <BannerTeam team={game.team_b} score={scoreB} testId="bs-score-b" reverse />
    </div>
  );
}
